import React from "react";

import Hero from "../components/Host";

function Landing() {
  return (
    <>
      <Hero />
    </>
  );
}

export default Landing;
